<div class="header-page">
    <div *ngIf="url === '/home'" [routerLink]="PAGES_AND_PATHS.nearYou.pagePath" class="wrapper-near-you-btn">
      <div class="wrapper-icon">
        <img src="../../../assets/icons/outline/icon-location.svg" alt="">
      </div>
      <span>{{'NEAR_YOU_PAGE.near_you' | translate}}</span>
    </div>
    <button *ngIf="url !== '/home'" (click)="goBack()" class="custom-btn custom-btn--circle-outline">
        <img src="../../../assets/icons/icon-arrow-left.svg" alt="">
    </button>
    <div class="options-header-right">
      <div class="wrapper-notification">
        <button #notificationBtn (click)="isNotificationsShow = !isNotificationsShow" class="custom-btn custom-btn--circle-outline">
          <img src="../../../assets/icons/outline/icon-notifications.svg" alt="">
        </button>
        <div *ngIf="hasUnreadNotifications" class="wrapper-circle-notification"></div>
        <tl-notifications @fadeInFadeOut *ngIf="isNotificationsShow"></tl-notifications>
      </div>
        <button class="custom-btn custom-btn--circle-outline" [routerLink]="PAGES_AND_PATHS.chat.pagePath">
            <img src="../../../assets/icons/outline/icon-chat.svg" alt="">
        </button>
        <div class="wrapper-btn-dropdown" [ngClass]="{'open-dropdown': isDropdownOpened}">
            <button #dropdownBtn (click)="isDropdownOpened = !isDropdownOpened" class="custom-btn custom-btn--circle-fill ">
                <img src="../../../assets/icons/outline/icon-menu.svg" alt="">
            </button>
            <div class="dropdown-content-btn">
                <div class="item-dropdown-btn" [routerLink]="PAGES_AND_PATHS.settings.pagePath">
                    <img src="../../../assets/icons/outline/icon-settings.svg" alt="">
                    <span>
                      {{'SETTINGS.settings' | translate}}
                    </span>
                </div>
                <div class="item-dropdown-btn" (click)="logout()">
                    <img src="../../../assets/icons/outline/icon-logout.svg" alt="">
                    <span>
                      {{'SETTINGS.log_out' | translate}}
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
